const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function parseMonth(value) {
  if (!value) return null;
  const trimmed = String(value).trim();
  const asNumber = parseInt(trimmed, 10);
  if (!Number.isNaN(asNumber) && asNumber >= 1 && asNumber <= 12) return asNumber;
  const idx = MONTH_NAMES.findIndex(
    (name) => name.toLowerCase().startsWith(trimmed.toLowerCase())
  );
  return idx >= 0 ? idx + 1 : null;
}

function parseYear(value) {
  if (!value) return null;
  const year = parseInt(String(value).trim(), 10);
  if (Number.isNaN(year) || year < 1900 || year > 2100) return null;
  return year;
}

function labelMatches(label, patterns) {
  const text = label.toLowerCase();
  return patterns.some((pattern) => text.includes(pattern));
}

function findFieldValue(root, labelPatterns) {
  if (!root) return '';

  const labels = root.querySelectorAll('label');
  for (const label of labels) {
    const labelText = label.textContent || '';
    if (!labelMatches(labelText, labelPatterns)) continue;

    const htmlFor = label.getAttribute('for');
    if (htmlFor) {
      const input = root.querySelector(`#${CSS.escape(htmlFor)}`);
      if (input?.value) return input.value.trim();
    }

    const container = label.closest('div');
    const input = container?.querySelector('input, textarea, select');
    if (input?.value) return input.value.trim();
  }

  const inputs = root.querySelectorAll('input[placeholder], textarea[placeholder]');
  for (const input of inputs) {
    const placeholder = (input.getAttribute('placeholder') || '').toLowerCase();
    if (labelPatterns.some((pattern) => placeholder.includes(pattern))) {
      if (input.value) return input.value.trim();
    }
  }

  return '';
}

/** Extract site, supervisor, year, and month from a safety form DOM node. */
export function extractFormSubmissionMeta(formElement) {
  const siteProject =
    findFieldValue(formElement, ['site / project', 'site/project', 'project name', 'location']) || '';
  const supervisor =
    findFieldValue(formElement, ['supervisor', 'foreman', 'inspected by']) || '';
  const yearRaw = findFieldValue(formElement, ['year']);
  const monthRaw = findFieldValue(formElement, ['month']);

  return {
    site_project: siteProject || undefined,
    supervisor_name: supervisor || undefined,
    year: parseYear(yearRaw) || undefined,
    month: parseMonth(monthRaw) || undefined,
  };
}

export function formatMonthLabel(monthNumber) {
  if (!monthNumber) return '—';
  const idx = Number(monthNumber) - 1;
  return MONTH_NAMES[idx] || String(monthNumber);
}
